import dayjs from 'dayjs'

import { CALL_HISTORY_LIMITED_DAYS, resolveCallDetailingEnabled } from './access-ui-resolvers'

/** Нижняя граница timestamp (unix sec) для списка вызовов без CDRsAccess. */
export const getLimitedCallHistoryMinTimestamp = (): number =>
  dayjs().subtract(CALL_HISTORY_LIMITED_DAYS, 'day').startOf('day').unix()

export const isCallTimestampWithinLimitedWindow = (timestamp: number): boolean =>
  timestamp >= getLimitedCallHistoryMinTimestamp()

/** Нужно ли ограничивать глубину списка истории вызовов. */
export const shouldLimitCallHistoryDepth = (): boolean => !resolveCallDetailingEnabled()
